import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/releases/actionTypes';
import { DETAILS_SOURCE } from 'modules/releases/constants';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

/**
 * @typedef {{
 *   loading: {
 *     initializing: boolean;
 *     saving: boolean;
 *   };
 * }} ReleasesUIDetailsReducer
 */

const isDetailsPageSourceMatcher = ({ meta }) => meta?.source === DETAILS_SOURCE;

export default combineReducers({
  loading: combineReducers({
    initializing: loading(types.FETCH_RELEASE_BY_ID, {
      global: { matcher: isDetailsPageSourceMatcher },
      reducers: {
        [LOCATION_CHANGE]: () => true,
      },
    }),
    saving: loading(types.UPDATE_RELEASE, {
      global: { matcher: isDetailsPageSourceMatcher }
    })
  }),
});
